import { render, staticRenderFns } from "./Product01.vue?vue&type=template&id=4a967211&scoped=true&"
import script from "./Product01.vue?vue&type=script&lang=js&"
export * from "./Product01.vue?vue&type=script&lang=js&"
import style0 from "./Product01.vue?vue&type=style&index=0&id=4a967211&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a967211",
  null
  
)

export default component.exports